import { render, staticRenderFns } from "./CollectionCard.vue?vue&type=template&id=0f9f59ea&scoped=true&"
import script from "./CollectionCard.vue?vue&type=script&lang=ts&"
export * from "./CollectionCard.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionCard.vue?vue&type=style&index=0&id=0f9f59ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9f59ea",
  null
  
)

export default component.exports